import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, TextField, Checkbox, FormControlLabel, CircularProgress } from '@mui/material';
import React, { useState, useEffect } from 'react';

interface ActiveCommonDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dialogType: 'switch_to_standby_server' | 'break_redundancy';
}

const ActiveCommonDialog: React.FC<ActiveCommonDialogProps> = ({ open, onClose, onConfirm, dialogType }) => {
  const [confirmText, setConfirmText] = useState('');
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (!open) {
      setConfirmText('');
      setIsCheckboxChecked(false);
    }
  }, [open]);

  const handleConfirm = () => {
    // Only allow the button to be clicked once.
    if (isConfirmed) return;
    if (dialogType === 'switch_to_standby_server' && confirmText.toLowerCase() === 'confirm') {
      setIsConfirmed(true);
      onConfirm();
    } else if (dialogType === 'break_redundancy' && isCheckboxChecked) {
      setIsConfirmed(true);
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      sx={{
        '& .MuiDialog-paper': {
          height: '40vh',
          backgroundColor: 'var(--card)',
        },
      }}>
      <DialogTitle sx={{ backgroundColor: 'var(--card)' }}>
        {dialogType === 'switch_to_standby_server' ? 'Are you sure you want to switch servers ?' : 'Are you sure you want to break the redundancy?'}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: 'var(--card)' }}>
        <DialogContentText>
          {dialogType === 'switch_to_standby_server' ? 'AMS will be down for several minutes. Enter "confirm" in field below to continue' : 'AMS will be down for several minutes. Confirm by checking the box below.'}
        </DialogContentText>
        {dialogType === 'switch_to_standby_server' ? (
          <TextField
            autoFocus
            margin="dense"
            type="text"
            fullWidth
            variant="outlined"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
          />
        ) : (
          <FormControlLabel
            control={<Checkbox checked={isCheckboxChecked} onChange={(e) => setIsCheckboxChecked(e.target.checked)} />}
            label="Yes, break Redundancy"
          />
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: 'var(--card)' }}>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={(dialogType === 'switch_to_standby_server' ? confirmText.toLowerCase() !== 'confirm' : !isCheckboxChecked) && !isConfirmed}>
          {isConfirmed ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            dialogType === 'switch_to_standby_server' ? 'Switch Server' : 'Break Redundancy'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActiveCommonDialog;